import { render } from "./WpeText.vue?vue&type=template&id=9469fd42"
import script from "./WpeText.vue?vue&type=script&lang=js"
export * from "./WpeText.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/options-controls/WpeText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9469fd42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9469fd42', __exports__)) {
    api.reload('9469fd42', __exports__)
  }
  
  module.hot.accept("./WpeText.vue?vue&type=template&id=9469fd42", () => {
    api.rerender('9469fd42', render)
  })

}


export default __exports__